import { ReactNode, ReactNodeArray } from "react";

import Modal from "@material-ui/core/Modal";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Theme } from '@material-ui/core';
import clsx from 'clsx';

import { useI18n } from "../hooks";
import { Button } from '.';


interface FormModalProps {
	openModal: boolean;
	closeModal(): void;
	loading?: boolean;
	onSubmit?: (() => Promise<void>) | (() => void);
	submitButtonText?: string;
	inputs?: ReactNode | ReactNodeArray;
	hideSubmit?: boolean;
	className?: string;
	width?: string;
	height?: string;
}

const FormModal: React.FC<FormModalProps> = ({ children, openModal, loading, onSubmit, submitButtonText, inputs, closeModal, hideSubmit = false, className, width, height }) => {

	const props = {
		width: width ? width : '55vw',
		height: height ? height : '89vh'
	}

	const classes = useStyles(props);
	const ok = useI18n(i => i.genericTable.ok);

	return (
		<Modal open={openModal} className={clsx(classes.modalContainer, className, !hideSubmit && classes.spaceBetween)}>
			<div className={classes.modalContentContainer}>
				<IconButton size='small' color='primary' className={classes.closeButton} disabled={loading} onClick={closeModal}>
					<CloseIcon />
				</IconButton>

				<div className={classes.content}>
					{children}

					{inputs && <div className={classes.inputsContainer}>
						{inputs}
					</div>}
				</div>

				{!hideSubmit && <div className={classes.submitWrapper}>
					<Button
						loading={loading}
						className={classes.submitButton}
						onClick={onSubmit}
					>
						{submitButtonText || ok}
					</Button>
				</div>}
			</div>
		</Modal>
	);
}

export default FormModal;

interface StyleProps {
	width?: string;
	height?: string;
}

const useStyles = makeStyles<Theme, StyleProps>(theme => ({
	modalContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column'
	},
	modalContentContainer: {
		width: ({ width }) => width,
		height: ({ height }) => height,
		margin: 'auto',
		background: '#FFF',
		padding: '10px 20px',
		overflowY: 'scroll',
		display: 'flex',
		flexDirection: 'column',
		[theme.breakpoints.down(800)]: {
			width: '100vw',
			height: '100vh'
		}
	},
	content: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
	},
	inputsContainer: {
		width: '33vw',
		[theme.breakpoints.down(800)]: {
			width: '70vw'
		}
	},
	submitWrapper: {
		display: 'flex',
		justifyContent: 'flex-end'
	},
	submitButton: {
		alignSelf: 'flex-end',
		margin: '6px 10px 8px',
	},
	closeButton: {
		alignSelf: 'flex-start'
	},
	spaceBetween: {
		justifyContent: 'space-between',
	},
}));